// extracted by mini-css-extract-plugin
module.exports = {"root":"YoutubeVideo_root__WbY2K"};